<template>
  <!--/22832329239/Camfrog_p_728x90_DWEB  -->
  <google-tag gpt-id="div-gpt-ad-1755541867612-0" />
</template>

<script>
import GoogleTag from "@/components/Ads/GoogleTag";

export default {
  name: "GoogleProfileHorizontal",
  components: { GoogleTag }
}
</script>
